import { Offer } from "./offer.model";
import { ClassOrString, FileMedias, Parameter, Verylys } from "./verylys";
import { ProductType } from './productType.model';
import { FileMedia } from "./filemedia.model";

export enum ProductAvailability {
    PREORDER = "pre-order",
    NEW = "new",
    COMINGSOON = "comingsoon",
    AVAILABLE = "available",
    HIDDEN = "hidden"
}

export enum CoverLogoPosition {
    TOP = "top",
    MIDDLE = "middle",
    BOTTOM = "bottom"
}

export interface Product extends Verylys {
    _id: string;
    friendly_id: string;
    file_medias: {
        hero: {
            HOME: FileMedias;
            PRODUCT: FileMedias;
        },
        icon: {
            TABLE: FileMedias;
            MENU: FileMedias;
        },
        game_cover: {
            MAIN: FileMedias;
            NO_LOGO: FileMedias;
        }
        logo: {
            MAIN: FileMedias;
        }
    };
    parameters: {
        availability: Parameter<ProductAvailability>;
        seo_url: Parameter<string>;
        shortname: Parameter<string>;
        seo_description: Parameter<string>;
        preorder_delivery_at: Parameter<string | Date>;
        preorder: Parameter<boolean>;
        order: Parameter<number>;
        cover_logo_position: Parameter<CoverLogoPosition>;
        seo_url_title: Parameter<string>;
    }

    offers: ClassOrString<Offer>[];
    type: ClassOrString<ProductType>;
}